import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"label":"Tipo de cadastro","placeholder":"Selecione o tipo de cadastro","items":_vm.items,"readonly":_vm.disabled && _vm.model,"item-text":"text","item-value":"value"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }